var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.posts && _vm.contentReady)?_vm._l((_vm.posts),function(post){return _c('PostItem',{key:post.id,attrs:{"post":post}})}):[_c('Loader')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }